import {  Directive, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';

@Directive({ 
    // tslint:disable-next-line: directive-selector
    selector: 'input[digitOnly]' })
export class DigitOnlyDirective {

  @ViewChild('refInput') refInput: ElementRef;
  @Input() digitOnly: string;
  fromMobile: boolean;
  digitsLength: number;
  constructor(private _el: ElementRef, private _cs: CommonService) {
    this.fromMobile = this._cs.mobileBrowser;
    this.digitsLength = this._cs.allowNoOfNumericDigitsInField;
  }

  @HostListener('keydown', ['$event']) onKeyDown(event) {

    const keyCode = event.which;
    const shiftKey = event.shiftKey;
    const key = event.key;
    const currentfieldLength = event.target.value.length;

    if (keyCode === 229) {
      setTimeout(() => {
        const reg = /[^0-9]/g;
        this._el.nativeElement.value = event.target.value.replace(reg, '');
          const patt1 = /[^\d]/g;
          const result = event.target.value.match(patt1);
          let createString = '';
          if (result != null) {
            for (let i = 0; i < event.target.value.length; i++) {
              const currentChar = event.target.value[i];
                if (
                  (currentChar === '0') ||
                  (currentChar === '1') ||
                  (currentChar === '2') ||
                  (currentChar === '3') ||
                  (currentChar === '4') ||
                  (currentChar === '5') ||
                  (currentChar === '6') ||
                  (currentChar === '7') ||
                  (currentChar === '8') ||
                  (currentChar === '9')
                  ) {
                    createString += currentChar;
                  }
            }
            this._el.nativeElement.value = createString;
          }

      }, 0);
    }
    if (
      ((this.fromMobile ? true : !shiftKey) && keyCode >= 48 && keyCode <= 57 &&
      key !== ')' &&  // 48 -ipad
      key !== '!' &&  // 49-ipad
      key !== '@' &&   // 50-ipad
      key !== '#' &&   // 51-ipad
      key !== '$' &&   // 52-ipad
      key !== '%' &&   // 53-ipad
      key !== '^' &&   // 54-ipad
      key !== '&' &&   // 55-ipad
      key !== '*' &&   // 56-ipad
      key !== '('      // 57-ipad
      ) || // NUMERIC 0 TO 9
      (keyCode >= 96 && keyCode <= 105 ) ||  // NUMERIC 0 TO 9
      keyCode === 8 || // backspace
      keyCode === 9 || // tab
      keyCode === 10 || // line feed
      keyCode === 13 || // enter
      keyCode === 16 || // SHIFT
      keyCode === 17 || // ctrl
      keyCode === 18 || // alt
      keyCode === 20 || // CAPS LOCK
      keyCode === 27 || // escape
      keyCode === 33 || // pageup
      keyCode === 34 || // pagedown
      keyCode === 35 || // end key
      keyCode === 36 || // home key
      (keyCode >= 37 && keyCode <= 40) || // arrow keys
      keyCode === 45 || // insert
      keyCode === 46 || // delete
      (keyCode === 112 && keyCode === 123 ) || // f1 to f12
      keyCode === 127 || // delete
      keyCode === 144  // num lock
      ) {
        if (currentfieldLength < this.digitsLength) {
          return true;
        } else {
          if (
            ((keyCode >= 48 && keyCode <= 57 ) || // NUMERIC 0 TO 9
            (keyCode >= 96 && keyCode <= 105 )) // NUMERIC 0 TO 9
          ) {
            return false;
          } else {
            return true;
          }
        }
    } else {
      return false;
    }
  }
}
